import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import SRMAuthContext from "../../store/saleRepresentativesManagementStore/saleRepresentativesManagement-auth-context";

const RequireSRMFormAuth = () => {
  const location = useLocation();
  const { clientAuthInfo } = useContext(SRMAuthContext);

  return (
    <>
      {clientAuthInfo.isLoggedIn ? (
        <Outlet />
      ) : (
        <Navigate to="/sale-representatives-management/login" replace state={{ from: location }} />
      )}
    </>
  );
};

export default RequireSRMFormAuth;
